"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchContentSuggestion = exports.getSearchSuggestions = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const searchEndpoints = {
    SearchSuggestions: {
        client: 'api/aem/search/suggestion',
    },
    SearchContentSuggestion: {
        client: 'api/aem/search/suggestion/content',
    },
};
const getSearchSuggestions = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { query }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, searchEndpoints.SearchSuggestions, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            query,
            mainWebshop: defaultRequestParams.mainWebshop,
            language: defaultRequestParams.language,
        },
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getSearchSuggestions = getSearchSuggestions;
const getSearchContentSuggestion = (_c, _d) => tslib_1.__awaiter(void 0, [_c, _d], void 0, function* ({ servicesEndpoint, isServer }, { elasticsearchIndex, query }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, searchEndpoints.SearchContentSuggestion, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: {
            index: elasticsearchIndex,
            q: query,
        },
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getSearchContentSuggestion = getSearchContentSuggestion;
//# sourceMappingURL=search.api.js.map